import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  DevicePhoneMobileIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  CodeBracketSquareIcon
} from '@heroicons/react/24/outline';

export default function Example() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1500,
      easing: "ease-out",
      once: true,
    });
  }, []);

  const cards = [
    {
      title: t('mobiluyumluluk'),
      description: t('mobildes'),
      icon: <DevicePhoneMobileIcon className="w-8 h-8 text-white" />,
      gradient: "from-[#36364d] to-[#47475a]",
    },
    {
      title: t('api'),
      description: t('apicontent'),
      icon: <CodeBracketSquareIcon className="w-8 h-8 text-white" />,
      gradient: "from-[#47475a] to-[#36364d]",
    },
    {
      title: t('performanceTitle'),
      description: t('performanceDescription'),
      icon: <RocketLaunchIcon className="w-8 h-8 text-white" />,
      gradient: "from-[#47475a] to-[#6b7280]",
    },
    {
      title: t('securityTitle'),
      description: t('securityDescription'),
      icon: <ShieldCheckIcon className="w-8 h-8 text-white" />,
      gradient: "from-[#36364d] to-[#6b7280]",
    },
  ];

  return (
    <div className="bg-[#1f1f2c]  ">
      <div className="w-full max-w-4xl mx-auto text-center py-4 md:pb-19 lg:pb-8 relative  z-10">
        <div className="relative z-20 ">
        <p className="max-w-[330px] md:max-w-3xl lg:max-w-full text-sm sm:text-base md:text-xl lg:text-2xl text-[#dcbc5c] font-aventa text-center mx-auto my-4 md:my-6 lg:my-8 px-4 animate__animated animate__fadeIn animate__delay-2s word-break break-words" aria-label="eticaret">
            {t('platformPower')}
          </p>

          <h2 className="inline-block text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold bg-gradient-to-b from-[#929292] via-[#FFFFFF] to-[#857f7f] bg-clip-text text-transparent pb-2 px-4 md:px-8 animate__animated animate__fadeIn animate__delay-1s" aria-label="performans">
            {t('platformPowerDescription')}
          </h2>

         
        </div>
      </div>
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        {/* <h2 className="text-center text-xl sm:text-2xl font-semibold text-[#dcbc5c]" data-aos="fade" data-aos-delay="300">
          {t('platformPower')}
        </h2>
        <p className="mx-auto mt-2 max-w-lg text-center text-3xl sm:text-4xl font-semibold tracking-tight bg-gradient-to-b from-[#f6f2f2] via-[#FFFFFF] to-[#857f7f] bg-clip-text text-transparent px-4 md:px-8"
          data-aos="fade" data-aos-delay="500">
          {t('platformPowerDescription')}
        </p> */}

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              data-aos="fade"
              data-aos-delay={300 + index * 100}
              className={`rounded-2xl p-6 shadow-lg bg-gradient-to-br ${card.gradient} text-white flex flex-col items-center text-center transition-transform transform hover:-translate-y-1 backdrop-blur-lg backdrop-opacity-60`}
            >
              <div className="mb-4 flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">

                {card.icon}
              </div>
              <h3 className="text-xl font-bold text-[#dcbc5c]" aria-label={t('card.title')}>{card.title}</h3>
              <p className="mt-2 text-base"aria-label={t('card.description')}>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
